import { render, staticRenderFns } from "./contactos-emergencia.vue?vue&type=template&id=b99f144a&"
import script from "./contactos-emergencia.component?vue&type=script&lang=ts&"
export * from "./contactos-emergencia.component?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports